import { IBusiness } from '../entities/businessBase';
import { normalizeUbNullDisplayValue } from '../constants/unmanagedBusinessAutoRegister';

/**
 * 取引のファクトリークラス
 */
export class BusinessFactory {
  /**
   * IBusinessを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IBusiness> = {}): IBusiness => {
    const business: Required<IBusiness> = {
      businessId: initialData.businessId ?? '',
      organizationId: initialData.organizationId ?? '',
      dataId: initialData.dataId ?? '',
      salesDestinationName: normalizeUbNullDisplayValue(
        initialData.salesDestinationName,
        initialData.placeholderFields,
        'salesDestinationName'
      ),
      salesDestinationNumber: normalizeUbNullDisplayValue(
        initialData.salesDestinationNumber,
        initialData.placeholderFields,
        'salesDestinationNumber'
      ),
      MOQ: initialData.MOQ,
      orderPackage: initialData.orderPackage,
      note: initialData.note,
      leadTime: initialData.leadTime,
      leadTimeUnit: initialData.leadTimeUnit,
      inTransitDays: initialData.inTransitDays,
      group: initialData.group,
      aggregateGroup: initialData.aggregateGroup,
      virtualChild: initialData.virtualChild,
      isTrashed: initialData.isTrashed,
      createAt: initialData.createAt,
      customerName: normalizeUbNullDisplayValue(initialData.customerName, initialData.placeholderFields, 'customerName'),
      customerNumber: normalizeUbNullDisplayValue(initialData.customerNumber, initialData.placeholderFields, 'customerNumber'),
      businessName: initialData.businessName,
      unit: initialData.unit,
      deliveryDestinationName: initialData.deliveryDestinationName,
      executionDate: initialData.executionDate,
      businessMemo: initialData.businessMemo,
      salesResults: initialData.salesResults ?? [],
      arrivals: initialData.arrivals ?? [],
      customerAnnounce: initialData.customerAnnounce ?? [],
      customerAnnounceDaily: initialData.customerAnnounceDaily ?? [],
      warehouse: initialData.warehouse ?? '',
      warehouseNumber: initialData.warehouseNumber ?? '',
      package: initialData.package ?? '',
      businessNumber: initialData.businessNumber ?? '',
      supplierName: initialData.supplierName ?? '',
      supplierNumber: initialData.supplierNumber ?? '',
      recommend: initialData.recommend ?? [],
      dataType: initialData.dataType,
      businessForecastState: initialData.businessForecastState,
      updatedAt: initialData.updatedAt,
      createdAt: initialData.createdAt,
      removeAt: initialData.removeAt,
      deleted: initialData.deleted,
      stdInventoryIndices: initialData.stdInventoryIndices,
      inventory: initialData.inventory,
      supplierAnnounce: initialData.supplierAnnounce,
      mvpInventory: initialData.mvpInventory,
      forecastForReceiptId: initialData.forecastForReceiptId,
      forecastForReceiptName: initialData.forecastForReceiptName,
      forecastForReceiptResponsibleUsers: initialData.forecastForReceiptResponsibleUsers ?? [],
      aggregateBusinessResponsibleUsers: initialData.aggregateBusinessResponsibleUsers ?? [],
      baseBusinessResponsibleUsers: initialData.baseBusinessResponsibleUsers ?? [],
      manufacturer: normalizeUbNullDisplayValue(initialData.manufacturer, initialData.placeholderFields, 'manufacturer'),
      endUser: normalizeUbNullDisplayValue(initialData.endUser, initialData.placeholderFields, 'endUser'),
      lastCheckedUser: initialData.lastCheckedUser,
      lastCheckedAt: initialData.lastCheckedAt,
      purchaseUnitPrice: initialData.purchaseUnitPrice,
      salesUnitPrice: initialData.salesUnitPrice,
      placeholderFields: initialData.placeholderFields,
      userUniqueNumber: initialData.userUniqueNumber,
      businessFreeColumnValues: initialData.businessFreeColumnValues,
    };

    return business;
  };
}
